(() => {
  const countdowns = [...document.querySelectorAll('[data-offer-countdown]')];
  if (!countdowns.length) return;

  const storageKey = 'kynora-offer-window-v1';
  const createExpiry = () => {
    const extraMinutes = Math.floor(Math.random() * 60);
    const extraSeconds = Math.floor(Math.random() * 60);
    return Date.now() + ((6 * 60 + extraMinutes) * 60 + extraSeconds) * 1000;
  };
  const readExpiry = () => {
    try {
      const stored = Number(localStorage.getItem(storageKey));
      if (Number.isFinite(stored) && stored > Date.now()) return stored;
      const expiry = createExpiry();
      localStorage.setItem(storageKey, String(expiry));
      return expiry;
    } catch (_) {
      return createExpiry();
    }
  };
  let expiry = readExpiry();
  const pad = value => String(value).padStart(2, '0');
  const render = () => {
    let remaining = Math.max(0, Math.floor((expiry - Date.now()) / 1000));
    if (remaining === 0) {
      expiry = createExpiry();
      try { localStorage.setItem(storageKey, String(expiry)); } catch (_) {}
      remaining = Math.floor((expiry - Date.now()) / 1000);
    }
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;
    const value = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    countdowns.forEach(node => {
      const output = node.querySelector('[data-countdown-value]');
      if (output) output.textContent = value;
      node.setAttribute('aria-label', `${node.dataset.countdownLabel || 'Offer ends in'} ${value}`);
    });
  };
  render();
  window.setInterval(render, 1000);
})();
